const LIST_QUERY = `
  query {
    listSettings {
      authenticator
      credentialUUID
      doorOpenAlarmSeconds
    }
  }
`

const LIST_BCID_QUERY = `
  query ListBCIDSettings($credentialUUID: String) {
    listBcidSettings (credentialUUID: $credentialUUID) {
      authenticatorMode
      wellnessEnabled
      wellnessSurvey {
        uuid
        questions
      }
      hidMobileAccess
    }
  }
`

const UPDATE_MUTATION = `
  mutation UpdateSetting(
    $authenticator: AuthenticatorType,
    $credentialUUID: String,
    $bcidSettings: BcidSettingsUpdateInput) {
    updateSettings(params: {
      authenticator: $authenticator
      credentialUUID: $credentialUUID
      bcidSettings: $bcidSettings
    })
  }
`

const UPDATE_DOOR_ALARM_MUTATION = `
  mutation UpdateSetting(
    $doorOpenAlarmSeconds: Int) {
    updateSettings(params: {
      doorOpenAlarmSeconds: $doorOpenAlarmSeconds
    })
  }
`
const settingQueries = {
  methods: {
    async listSettingsQuery() {
      try {
        const result = await this.graphQuery(LIST_QUERY)
        return result.listSettings
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateSettingsMutation(authenticator) {
      try {
        const result = await this.graphQuery(UPDATE_MUTATION, authenticator)
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateSettingsDoorAlarmMutation(doorOpenAlarmSeconds) {
      try {
        const result = await this.graphQuery(UPDATE_DOOR_ALARM_MUTATION, {doorOpenAlarmSeconds})
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async listBCIDSettings(credentialUUID) {
      try {
        const result = await this.graphQuery(LIST_BCID_QUERY, {credentialUUID})
        return result.listBcidSettings
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default settingQueries
